'use strict';

const delivery = require('./delivery');
const locker = require('./locker');
const addEditAddress = require('./addEditAddressTab');
const geolocation = require('./geolocation');
const geocode = require('./geocode');
const deliveryUtils = require('./deliveryUtils');
const googleMapsUtil = require('./googleMapsUtil');

//Global variables
let $tabsCointainer = null;
let $modalOverlay = null;
let $modal = null;
let $footer = null;
let $deliveryTab = null;
let $lockerTab = null;
let $addAddressBtn = null;

/**
 * Classes toggler to activate delivery tab
 */
function setDeliveryTypeConfigs($tab) {
    const $currentTab = $tab.length ? $tab : $deliveryTab;

    const loginSectionTextDelivery =  $footer.find('.login-section.delivery');
    const loginSectionTextLocker =  $footer.find('.login-section.locker');
    const submitButtonDeliveryContainer= $footer.find('.change-delivery-address').parent();
    const submitButtonLockerContainer= $footer.find('.change-locker-address').parent();


    if ($currentTab.hasClass('delivery')) {
        submitButtonLockerContainer.addClass('d-none');
        loginSectionTextLocker.addClass('d-none');
        submitButtonDeliveryContainer.removeClass('d-none');
        loginSectionTextDelivery.removeClass('d-none');
        $addAddressBtn.removeClass('d-none');
    }
    else {
        submitButtonDeliveryContainer.addClass('d-none');
        loginSectionTextDelivery.addClass('d-none');
        submitButtonLockerContainer.removeClass('d-none');
        loginSectionTextLocker.removeClass('d-none');
    }
}

/**
 * Moves the saved address to the top if it matches the delivery address.
 * @param {jQuery} $selectedItem - The jQuery element representing the selected saved address.
 * @param {Object} savedAddressInfo - The data object for the saved address.
 * @param {Object} deliveryAddress - The address object that we want to match against.
 */
function moveSelectedSavedAddressToTop() {
    const $deliveryTabContent = $modal.find('#delivery-tab-pane').first();
    const $selectedItem = $(this); // Utiliza 'this' dentro de la función
    const $container = $selectedItem.parent();
    const iconUrl = $container.data('active-item-icon-url');
    $selectedItem.find('.saved-address-img').attr('src', iconUrl);
    $selectedItem.prependTo($container);
    $selectedItem.addClass('address-active');
    $deliveryTabContent.find('.list-group').addClass('savedAddress-selected');
}

/**
 * Classes toggler to activate delivery tab
 * @requires jQuery
 * @returns {void}
 */
function activateDeliveryTab() {
    locker.closeTab();
    $tabsCointainer.removeClass('active');
    delivery.openTab();
    setDeliveryTypeConfigs($deliveryTab);

    const $deliveryTabContent = $modal.find('#delivery-tab-pane').first();
    const $emptyStateHintDelivery =  $footer.find('.empty-state-hint.delivery');
    const $emptyStateHintLocker =  $footer.find('.empty-state-hint.locker');

    $emptyStateHintDelivery.addClass('d-none');
    $emptyStateHintLocker.addClass('d-none');

    const savedAddresses = $deliveryTabContent.find('.list-group-saved-addreses').children();
    const hasSavedAddresses = savedAddresses.length > 0;
    const hasSelectedAddress = $deliveryTabContent.find('.list-group').children().length > 0;
    $addAddressBtn.removeClass('d-none');

    if (deliveryUtils.isDeliveryAddressSet()) {
        const { deliveryAddress } = deliveryUtils.getDeliveryAddress();

        savedAddresses.each(function () {
            const savedAddressInfo = $(this).data('address-info');
            if ((savedAddressInfo.name && deliveryAddress.addressName)
                && (savedAddressInfo.name.toUpperCase() === deliveryAddress.addressName.toUpperCase())) {
                moveSelectedSavedAddressToTop.call(this);

                return false;
            }
        });
    }

    if (!hasSelectedAddress && !hasSavedAddresses) {
        $emptyStateHintDelivery.removeClass('d-none');
    }
}

/**
 * Classes toggler to activate locker tab
 * @requires jQuery
 * @returns {void}
 */
function activateLockerTab() {
    delivery.closeTab();
    $tabsCointainer.removeClass('active');
    locker.openTab();
    setDeliveryTypeConfigs($lockerTab);

    const $lockerTabContent = $modal.find('#locker-tab-pane').first();
    const $emptyStateHintDelivery =  $footer.find('.empty-state-hint.delivery');
    const $emptyStateHintLocker =  $footer.find('.empty-state-hint.locker');

    $emptyStateHintDelivery.addClass('d-none');
    $emptyStateHintLocker.addClass('d-none');
    $addAddressBtn.addClass('d-none');

    if (!$lockerTabContent.find('.list-group').children().length > 0) {
        $emptyStateHintLocker.removeClass('d-none');
    }
}
/**
 * Detects delivery type to show the matched tab
 * @requires jQuery
 * @returns {void}
 */
function detectDeliveryType() {
    if (!deliveryUtils.isDeliveryAddressSet()) {
        //If no delivery type is set, the delivery tab is openned by default
        activateDeliveryTab();
        return;
    }

    let deliveryData = deliveryUtils.getDeliveryAddress();

    if (deliveryData.isDeliveryTypeDelivery) {
        activateDeliveryTab();
        delivery.renderSelectedDeliveryMethod(deliveryData.deliveryAddress);
    }
    else if (deliveryData.isDeliveryTypeLocker) {
        activateLockerTab();
        locker.renderSelectedStore(deliveryData.deliveryAddress);
    }
}

/**
 * Opens modal
 * @returns {void}
 */
function handleOpenModal() {
    delivery.reset();
    locker.reset();
    $('body').addClass('no-scroll');
    $modalOverlay.removeClass('d-none');
    detectDeliveryType();

    googleMapsUtil.loadScript().then(() => {
        geolocation.initGeolocation(handleCurrentLocationClick);
        delivery.initAutocomplete();
        locker.initAutocomplete();
    })
}

/**
 * Detect if tab is the delivery tab
 * @requires jQuery
 * @param {jQuery} tab Tab element
 * @returns {boolean} isDeliveryTab
 */
function isDeliveryTab(tab) {
    return tab.attr('id') === 'delivery-tab-pane';
}

/**
 * Success function for geolocation
 * @param {Function} addressCallback Function to send the address response
 * @returns {Function} Wrapped success handler
 */
function currentPositionSuccess(addressCallback) {
    return async function(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        try {
            const address = await geocode.getAdddressForLocation(latitude, longitude);

            if (!address) {
                console.error('No se pudo obtener la dirección, pero sí la ubicación.');
                return;
            }

            addressCallback(address, latitude, longitude);
        } catch (error) {
            console.error('Error en geocoding:', error);
        }
    };
}

/**
 * Inits geolocation
 * @requires jQuery
 * @returns {void}
 */
function handleCurrentLocationClick() {
    const tab = $(this).parents('.tab-pane').first();

    if (isDeliveryTab(tab)) {
        const inputAddress = $(document).find('.input-delivery');
        inputAddress.focus();
        delivery.clearErrors();
        geolocation.getCurrentPosition(
            currentPositionSuccess(delivery.addressFound),
            delivery.setLocationError
        );
    }
    else {
        const inputAddress = $(document).find('.input-locker');
        inputAddress.focus();
        locker.clearErrors();
        geolocation.getCurrentPosition(
            currentPositionSuccess(locker.addressFound),
            locker.setLocationError
        );
    }
}

/**
 * close modal and remove overlay
 * @params {$modal} current modal
 */
function handleModalClose() {
    $modal.removeClass('show');
    $modal.addClass('closing');
    $('body').removeClass('no-scroll');

    setTimeout(() => {
        $modal.modal('hide');
        $modal.removeClass('closing');
        $modalOverlay.addClass('d-none');
    }, 400);
}

/**
 * Entrypoint
 * @requires jQuery
 * @returns {void}
 */
function initDeliveryModal() {
    //Gets the modal
    $modal = $('#deliveryModal');
    //modal footer
    $footer = $modal.find('.modal-footer');
        //modal overlay
    $modalOverlay = $modal.parent().find('.modal-overlay');
    //Assign tabs container
    $tabsCointainer = $modal.find('.nav-item');
    //Assign delivery elements
    $deliveryTab = delivery.initTab($modal);
    //Click on delivery tab
    $deliveryTab.on('click', activateDeliveryTab);
    //Assign locker elements
    $lockerTab = locker.initTab($modal);
    //click on locker tab
    $lockerTab.on('click', activateLockerTab);
    //Add new address section
    addEditAddress.initTab($modal);
    $addAddressBtn = $footer.find('.add-address-btn');
    $addAddressBtn.on('click', addEditAddress.handleShowAddAddressTabClick);

    //Actions triggered on modal open
    $modal.on('show.bs.modal', handleOpenModal);

    $modal.find('.btnClose').on('click', handleModalClose);

    $modalOverlay.on('click', handleModalClose);

    $(document).on('handleShippingMethodsModalClose', handleModalClose)
}

module.exports = {
    init : function () {
        initDeliveryModal();
    }
};
